import { useCallback, useMemo } from 'react';
import { Column } from '../../../components/ListV2/components/table/VirtualizedTable.types';
import LangEnum from '../../../lang/LangEnum';

export interface UseSummarizeColumnsProps<T> {
  visibleColumns: Column<T>[];
}

export const useSummarizeColumns = <T,>({ visibleColumns }: UseSummarizeColumnsProps<T>) => {
  const visibleColumnsTitles = visibleColumns.map((column) => column.title as LangEnum);

  const getColspan = useCallback(
    (summarizeColumns: LangEnum[]) => {
      const indexOfLastVisibleColumn = visibleColumnsTitles.findIndex((columnTitle) =>
        summarizeColumns.includes(columnTitle as LangEnum),
      );

      return indexOfLastVisibleColumn === -1
        ? visibleColumnsTitles.length
        : indexOfLastVisibleColumn;
    },
    [visibleColumnsTitles],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: Só precisamos renderizar novamente se as colunas visíveis mudarem
  const summarizeColumns = useMemo(() => {
    return visibleColumns.filter((column) => !!column.renderTopColumn);
  }, [visibleColumns, visibleColumnsTitles]);

  const colspan = getColspan(summarizeColumns.map((column) => column.title as LangEnum));
  const fillerColumnCount = visibleColumns.length - colspan - summarizeColumns.length;

  return {
    summarizeColumns,
    colspan,
    fillerColumnCount,
  };
};
